//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import DetailProductDialogContent from '../../../components/detailProductDialogContent/-index.vue';
import viewportMixin from '@/mixins/viewport.mixin';

export default {
  components: { DetailProductDialogContent },
  mixins: [viewportMixin],
  props: {
    addToBasket: {
      type: Function,
      default: () => {},
    },
    removeFromBasket: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      dialogAlertContainerStyle: {},
      isMaximized: false,
    };
  },
  computed: {
    ...mapGetters('sale', ['isCompanyCatalog', 'isSaleWithoutPrice']),
  },
  mounted() {
    this.breakpointsHandler();
    this.setMaximized();
    window.addEventListener('resize', this.breakpointsHandler);
    window.addEventListener('resize', this.setMaximized);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.breakpointsHandler);
    window.removeEventListener('resize', this.setMaximized);
  },
  methods: {
    breakpointsHandler() {
      if (window.innerWidth <= 1279 && window.innerWidth >= 1024) {
        this.dialogAlertContainerStyle = {
          padding: '0px',
          'max-width': '788px',
          width: '788px',
        };
        return;
      }

      if (window.innerWidth <= 1024 && window.innerWidth >= 768) {
        this.dialogAlertContainerStyle = {
          padding: '0px',
          'max-width': '768px',
          width: '768px',
        };
        return;
      }

      if (window.innerWidth <= 767) {
        this.dialogAlertContainerStyle = {
          padding: '0px',
          'max-width': '100%',
          width: '100%',
        };
        return;
      }

      if (window.innerWidth >= 1280) {
        this.dialogAlertContainerStyle = {
          padding: '0px',
          'max-width': '1160px',
          width: '1160px',
        };
      }
    },
    setMaximized() {
      this.isMaximized = window.innerWidth <= 767;
    },
  },
};
